import { CalendarIcon } from '@chakra-ui/icons'
import { Button, forwardRef } from '@chakra-ui/react'
import moment from 'moment'

const PickerInput = forwardRef(({ onClick, confirmedDates }, ref) => (
  <Button
    ref={ref}
    leftIcon={<CalendarIcon />}
    borderColor="#c2c4cc"
    borderRadius="md"
    px={3}
    size="sm"
    color="#333"
    variant="outline"
    fontWeight="400"
    onClick={onClick}
  >
    {confirmedDates
      ? `${moment(confirmedDates[0]).format('D MMM Y')} - ${moment(
          confirmedDates[1]
        ).format('D MMM Y')}`
      : ''}
  </Button>
))

export default PickerInput
